import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (
	item: PaymentFromExecutorCashPeriodCellContent.Props["item"],
) => {
	if (!isNumber(item?.manualReplenishmentPeriod)) return formatNumber(0);
	return formatNumber(item?.manualReplenishmentPeriod);
};

const PaymentFromExecutorCashPeriodCellContent: React.FC<
	PaymentFromExecutorCashPeriodCellContent.Props
> = ({ item }) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace PaymentFromExecutorCashPeriodCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default PaymentFromExecutorCashPeriodCellContent;
